/* global dataLayer */

import 'whatwg-fetch';
import './FormSubscribe.scss';

import React, { Fragment } from 'react';

import PropTypes from 'prop-types';
import classNames from 'classnames';

class FormSubscribe extends React.Component {
    state = {
        email: '',
        business: '',
        education: '',
        digitalcrime: '',
        emailValid: false,
        showErrors: false,
        success: false,
        error: false,
        isLoading: false,
        hasError: false,
        bgcolor: '',
        preamble: ''
    };


    onChange = (e) => {
        this.setState({
            [e.target.name]: e.target.checked,
            hasError: false,
        });
    };


    updateValue = (e) => {
        const field = e.target.name;
        this.setState({
            [field]: e.target.value,
            showErrors: true,
        });
    };

    submit = (e) => {
        e.preventDefault();
        const topic = this.props.topic;
        const { email, business, education, digitalcrime, isLoading, hasError } = this.state;
        // let noneSelectedError = false;
        // if(!noneSelectedError) {

        const postBody = JSON.stringify({
            email,
            topic: topic || 'B2C', // Default topic if none provided
            business: business || false,
            education: education || false,
            digitalcrime: digitalcrime || false,
            lead: this.props.lead || ''
        });

        this.setState({
            isLoading: true,
        });

        fetch('/wp-json/ssf/newsletter', {
            method: 'post',
            body: postBody,
            headers: new Headers({
                'Content-Type': 'application/json',
            }),
        })
        .then((response) => {

            if (response.ok) {
                this.setState({
                    isLoading: false,
                });
                this.setState({
                    success: true,
                });

                dataLayer.push({
                    'event': 'submitForm',
                    'formTitle': this.props.formName
                });
            } else {
                this.setState({
                    isLoading: false,
                });
                this.setState({
                    error: true,
                });
            }
        })
        .catch(() => {
            this.setState({
                isLoading: false,
            });
            this.setState({
                error: true,
            });
        });
    };

    render() {
      const { title, preamble, buttonText, terms, successText, errorText } = this.props;
      const { email, showErrors, isLoading, success, error } = this.state;

      return (
          <form
              className={classNames('FormSubscribe', this.props.bgcolor, {
                  'FormSubscribe--ShowErrors': showErrors,
                  'FormSubscribe--isLoading': isLoading,
              })}
              onSubmit={this.submit}>
              <div className="FormSubscribe__Container">
                  <h2 className="FormSubscribe__Title">{title}</h2>
                  <p className="FormSubscribe__Preamble">{preamble}</p>
                  <div className="FormSubscribe__Content">
                      {!success && !error ? (
                          <Fragment>
                              <div className="FormSubscribe__Fields">
                                  <input aria-label="Ange e-post" className="FormSubscribe__Field" type="email" name="email" onChange={this.updateValue} value={email} required />
                                  <input className="FormSubscribe__Button" aria-label={buttonText} type="submit" value={buttonText} />
                              </div>
                              <div
                                  className="FormSubscribe__Terms"
                                  dangerouslySetInnerHTML={{ __html: terms }}
                              />
                          </Fragment>
                      ) : (
                          <Fragment>
                              {success ? (
                                  <div className="FormSubscribe__Message" dangerouslySetInnerHTML={{ __html: successText }} />
                              ) : (
                                  <div className="FormSubscribe__Message" dangerouslySetInnerHTML={{ __html: errorText }} />
                              )}
                          </Fragment>
                      )}
                  </div>
              </div>
          </form>
      );
    };
}

FormSubscribe.propTypes = {
    topic: PropTypes.string,
    title: PropTypes.string,
    buttonText: PropTypes.string,
    terms: PropTypes.string,
    successText: PropTypes.string,
    errorText: PropTypes.string,
    noneSelected: PropTypes.string,
    formName: PropTypes.string,
};

FormSubscribe.defaultProps = {};

export default FormSubscribe;
